export default __webpack_public_path__ + "static/media/extrato_financeiro_gestor.837f0ce1.png";